import { View, ScrollView } from 'react-native-web'
import React from 'react'
import { Body, SubTitle, Title } from '../../../element/Text'


export default function BookRoomDescription({item, title, subtitle}){
  return (
    <ScrollView style={{width:'90%',height:'80%', padding:15, alignSelf:'center', marginTop:15, marginBottom:15, backgroundColor:'#252525', borderRadius:16, borderColor:'#F9BA49', borderWidth:1.8}} contentContainerStyle={{alignItems:'center', marginBottom:15, }} showsVerticalScrollIndicator={false}>
      <Title value={title} color1={'#F9BA49'}/> 
      <SubTitle value={subtitle} color1={'#F9BA49'}/>
      <Body value={item} color1={'#F9BA49'}/>
    </ScrollView>);}



